
import { ReactNode,  useEffect, useRef, useState } from "react";


import { UpdateStyleFunction } from "../Stylebuilder";
import { pulseUISelection } from "../Utilities/ElementAnimator";
import { elementResizeLockedKey } from "../Data/ConstantKeyWords";

import { AttributeTargetType} from "../Data/WBData";

import { AttributeCollection, getNodeStyleAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { ResizeableType, WBComponent } from "../WBComponents/WBComponent";
import HoverToolTip from "../HoverToolTip";
import SelectDropdown from "../SelectDropdown";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
const autoExpandString = "Fit";

export default function HeightAndWidthField({
    label,
    domObject,
    screenSize,
    layoutObject,
    component,
    updateFunc,
    
    widthAtt,
    heightAtt,
    xLabel,
    yLabel,
    includeLock = true,

  }: {
    label:ReactNode,
    domObject: HTMLElement|null;
    screenSize:ScreenSize;
    layoutObject: AttributeCollection;
    component:WBComponent,
    updateFunc: UpdateStyleFunction;
    widthAtt: string;
    heightAtt: string;
    xLabel:string;
    yLabel:string;
    includeLock?: boolean;
   
  }) {



    let lockedRatio = layoutObject.componentAttributes[elementResizeLockedKey]??"";

    const [widthAndHeight,setWidthAndHeight] = useState("unknown");
    const [locked, setLocked] = useState((lockedRatio.length>0));
    const inputRowRef = useRef(null);
  

 






    const updateObservedValuesOnMouseMove = ()=>{

        if(domObject){
        let hwString = domObject.style.width +domObject.style.minWidth+domObject.style.minHeight+ domObject.style.height;


            if(hwString!=widthAndHeight){

                if(inputRowRef.current && widthAndHeight!="unknown"){
                 
                    pulseUISelection((inputRowRef.current as HTMLElement).parentElement,500);
                }

                setWidthAndHeight(hwString);
            }
        }

    }

    //hook to catch the update values
    const updateValues = (attribute:string,value:string)=>{


        if(locked && includeLock){

         

            let lockedRatio = parseFloat(layoutObject.componentAttributes[elementResizeLockedKey]??"1");
            let setAtt = (attribute==widthAtt)?heightAtt:widthAtt;
            let current = getUnitAndValueFromMeasurement(value);
            let newValue = 0;

            if(attribute==widthAtt)
                newValue = Math.round(current.value/lockedRatio);
            else
                newValue = Math.round(current.value*lockedRatio);

            updateFunc(setAtt,newValue+current.unit,AttributeTargetType.Style);
               


        }


        updateFunc(attribute,value,AttributeTargetType.Style);
    } 

    const toggleLock= (shouldLock:boolean)=>{

        if(!shouldLock)
            delete layoutObject.componentAttributes[elementResizeLockedKey]; // don't use setNodeComponentAttributeValue here because we don't care if this value is in the edit list
        else{
            layoutObject.componentAttributes[elementResizeLockedKey] = "true";
            let dom = document.getElementById(layoutObject.id);
            
            if(dom){
                let bounds = dom.getBoundingClientRect();
                let ratio = bounds.width/bounds.height;
                layoutObject.componentAttributes[elementResizeLockedKey] = ratio.toString();
                
            }
        }



        setLocked(shouldLock);


    }

    useEffect(() => {

        
      document.addEventListener("mousemove",updateObservedValuesOnMouseMove);

      return () => {
      
          document.removeEventListener("mousemove",updateObservedValuesOnMouseMove);
        
      };
    });
  



    let hasWidth = component.resizeType!= ResizeableType.None && component.resizeType!= ResizeableType.VerticalOnly;// component.editList.includes(widthAtt);
    let hasHeight =  component.resizeType!= ResizeableType.None && component.resizeType!= ResizeableType.HorizontalOnly;//component.editList.includes(heightAtt);

    const lockIcon =(hasHeight&&hasWidth )? (locked ? <LockClosed /> : <LockOpen />):<LockNA />;

    return (
        <div  id="hw-group" style={{padding:"4px",borderRadius:'4px',marginLeft:"-4px"}} >
        <div className="wb-input-row gap-small" style={{flexDirection:"column",paddingRight:(includeLock?"28px":"")}} ref={inputRowRef}>
     
       
          <SizingGroup
          screenSize={screenSize}
            label={xLabel}
            att={widthAtt}
            layoutObject={layoutObject}
            onChangeFunc={updateValues}
            visible={hasWidth}

          />
                    {   (hasWidth&&hasHeight && includeLock)? 
             <div className="flex-row justify-end w-full relative" style={{height:"8px",marginRight:"-50px"}}> 
            <button className="lock-button" onClick={() => toggleLock(!locked)}>{lockIcon} <HoverToolTip text="Lock aspect ratio"/></button>
            </div>:
            (includeLock)&&
             <div className="flex-row justify-end w-full relative" style={{height:"8px",marginRight:"-46px"}}>
            <div className="lock-button" style={{opacity:".5"}}>{lockIcon} </div>
            </div>
            }
      
          <SizingGroup
            screenSize={screenSize}
            label={yLabel}
            att={heightAtt}
            layoutObject={layoutObject}
            onChangeFunc={updateValues}
            visible={hasHeight}

          />
        
            

        
        </div>
      </div>
    );
  }


function getDefaultWidthString(typename:string){
    switch(typename){
        case wBComponentTypeNames.busienssStaff:
        case wBComponentTypeNames.businessPackages:
        case wBComponentTypeNames.businessGiftCertificates:
        case wBComponentTypeNames.businessBookNow:
        case wBComponentTypeNames.businessServices:
        case wBComponentTypeNames.businessClass:
        case wBComponentTypeNames.businessFacilityInformation:
        case wBComponentTypeNames.businessForm:
        case wBComponentTypeNames.businessGallery:
        case wBComponentTypeNames.businessMemberships:
        case wBComponentTypeNames.businessProducts:
        case wBComponentTypeNames.businessreviewpercentage:
        case wBComponentTypeNames.businessReviews:
            return "100%";
        default:
              return "Auto";
        

    }
}

function SizingGroup({layoutObject,label,att,onChangeFunc,visible,screenSize}:{layoutObject:AttributeCollection,label:string,att:string,onChangeFunc:UpdateStyleFunction,visible:boolean,screenSize:ScreenSize}){

    const textRef = useRef<HTMLInputElement>(null);
    const selectRef = useRef<HTMLInputElement>(null);
    const style = visible?{}:{opacity:".4",pointerEvents:"none",userSelect:"none"};
    //dont risk removing state change until validating @todo
    // eslint-disable-next-line 
    const [currentUnit,setCurrentUnit] = useState("");
    const onAnyUpdate = ()=>{

        if(textRef.current && selectRef.current){


            if(textRef.current.value == autoExpandString){

               let newVal = (att=="width")?getDefaultWidthString(layoutObject.typename):"Auto";

                onChangeFunc(att,newVal,AttributeTargetType.Style);
                return;
            }

            let newNum = textRef.current.value;
            
          

          


            newNum = newNum.replace(/[a-zA-Z]/g, "");
         
            if(!newNum||newNum.length<=0||newNum=="NaN"){
                newNum = "";
            
            }

    
            textRef.current.value = newNum;
            
            let newUnit = selectRef.current.value;
           

            let newValue = (newNum.length>0)? newNum+newUnit:"";

            
            
            onChangeFunc(att,newValue,AttributeTargetType.Style);
            setCurrentUnit(newUnit);
        }
   
    }

    let getVal = getNodeStyleAttributeValue(layoutObject,screenSize, att);

    //saftey check related to images auto setting their height at the component level
    if(getVal.includes("Auto")&&getVal!="Auto"){
        setNodeStyleAttributeValue(layoutObject,screenSize,att,"Auto");
        getVal = "Auto";
    }

    //getVal = document.getElementById(layoutObject.id)?.style.width??"Auto";
    let unit = getVal.replace(/[0-9.\s]/g, "");
    if(unit.length<=0)
        unit = "px";

    let num = parseFloat(getVal);

    let val = (!getVal||getVal==""||isNaN(num))?"":num.toString();




    useEffect(()=>{

        let testVal = (att=="width")?getDefaultWidthString(layoutObject.typename):"Auto";
        
        if(textRef.current ){
            if(getVal==testVal){
                textRef.current.type = "text";
                textRef.current.value = autoExpandString
            }
            else{
                textRef.current.type = "number";
                textRef.current.value = val;
            }
    
        }
        if(selectRef.current){
            selectRef.current.value = unit;
        }

    });
   
    const checkey = (e:React.KeyboardEvent<HTMLInputElement>)=>{


        if (selectRef.current) {
          if (e.key == "p") {
            selectRef.current.value = "px";
            onAnyUpdate();
          } else if (e.key == "%") {
            selectRef.current.value = "%";
            onAnyUpdate();
          }
        }
    }

    let testVal = (att=="width")?getDefaultWidthString(layoutObject.typename):"Auto";

    let isAuto = getVal==testVal;

    return(
        <div className="sizing-input-group" style={style as any} >
    
            <label style={{textTransform:"capitalize"}}>{label}</label> 
            <div className="w-full relative">
            <input onKeyDown={checkey} ref={textRef} type={isAuto?"text":"number"} min="0" defaultValue={(isAuto?autoExpandString: val)} placeholder={ "Auto"} onInput={()=>onAnyUpdate()}/> 
    
           
            <div className="input-auto-button-field">
                <button className="w-button w-button-primary w-full" onMouseDown={()=>{
                    if(textRef.current){
                    textRef.current.type = "number"
                    textRef.current.value = "";onAnyUpdate();
                    }

                
                }} >Clear</button>
                       {(att=="width"||att=="height")&&
                  <button className="w-button w-button-primary w-full" onMouseDown={()=>{
                    if(textRef.current){
                     textRef.current.type = "text";
                    textRef.current.value = autoExpandString; onAnyUpdate();
                    }

                
                }} >{autoExpandString}</button>
                    }
            </div>
    
            </div>
            <UnitSelector unit = {unit} setRef={selectRef} onChangeFunc={()=>onAnyUpdate()}/>
        </div>
    )
}


function UnitSelector({onChangeFunc,unit,setRef}:{unit:string,onChangeFunc:Function,setRef:any}){



    return(


        <>
    <select className="unit"  style={{display:"none"}}defaultValue={unit} ref={setRef} onChange={()=>onChangeFunc()}>
        <option value={"px"}>px</option>
        <option value={"%"}>%</option>
        <option value={"vw"}>vw</option>
        <option value={"vh"}>vh</option>

    </select>


    <SelectDropdown key={unit} options={[
        {label:"px",value:"px"},
        {label:"%",value:"%"},
        ]} defaultValue={unit} onChange={(val:string)=>{
            
            if(setRef.current){
                setRef.current.value = val;
            }

          
            onChangeFunc()}} /> 
        

    </>
    )
}

function LockOpen(){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor">
            <path d="M432.3 0C352.8-.2 288 64.5 288 144v48H48c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48h-64v-46.8c0-52.8 42.1-96.7 95-97.2 53.4-.6 97 42.7 97 96v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-54.6C576 65.8 512 .2 432.3 0zM400 240v224H48V240h352z"/></svg>
    )
}

function LockClosed(){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor">
        <path d="M400 192h-32v-46.6C368 65.8 304 .2 224.4 0 144.8-.2 80 64.5 80 144v48H48c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48zm-272-48c0-52.9 43.1-96 96-96s96 43.1 96 96v48H128v-48zm272 320H48V240h352v224z"/></svg>
    )
}

function LockNA(){


    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor">
            <path d="M240 128l0 34.8c12.4 9.7 24.8 19.5 37.3 29.2c40.9 0 81.8 0 122.7 0c0-21.3 0-42.7 0-64c0-44.2-35.8-80-80-80s-80 35.8-80 80zM320 0c70.7 0 128 57.3 128 128c0 21.3 0 42.7 0 64c10.7 0 21.3 0 32 0c35.3 0 64 28.7 64 64c0 48.4 0 96.7 0 145.1c28.9 22.7 57.9 45.4 86.8 68c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1C403.8 352.2 206.5 197.6 9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1C89.9 45.1 141 85.2 192 125.2C193.5 55.8 250.2 0 320 0zM496 256c0-8.8-7.2-16-16-16c-47.2 0-94.3 0-141.5 0c52.5 41.1 105 82.3 157.5 123.4c0-35.8 0-71.6 0-107.4zM480 512l-320 0c-35.3 0-64-28.7-64-64c0-64 0-128 0-192c0-24.8 14.1-46.3 34.8-56.9c17.3 13.6 34.6 27.3 52 40.9c-7.6 0-15.2 0-22.8 0c-8.8 0-16 7.2-16 16c0 64 0 128 0 192c0 8.8 7.2 16 16 16c102.4 0 204.7 0 307.1 0c15.9 12.6 31.9 25.1 47.8 37.7c-10 6.5-22 10.3-34.9 10.3z"></path></svg>
    )
}

function getUnitAndValueFromMeasurement(getVal:string){
    let unit = getVal.replace(/[0-9.\s]/g, "");
    if(unit.length<=0)
        unit = "px";

    let num = parseFloat(getVal);
    let val = (getVal=="Auto")?0:num;

    return {unit:unit,value:val};
}

